import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_BILLING_RATE_TYPES } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const billRateTypes = {
  namespaced: true,
  state: buildInitialState({
    billRateTypesList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setBillRateTypes: (state, billRateTypes) => {
      state.billRateTypesList = billRateTypes
    }
  },
  actions: {
    getBillRateTypes: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_BILLING_RATE_TYPES })
        .then(json => json.data)
        .then(billRateTypes => {
          commit('updateStatus', { status: COMPLETE })
          commit('setBillRateTypes', billRateTypes)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default billRateTypes
